module.exports = __webpack_public_path__ + "static/media/details1.0b253958.jpeg";